export const STEPS_LIST = [
  {
    name: 'Investing or Holding Entity',
  },
  {
    name: 'Fine Art and Collectables',
  },
  {
    name: 'Valuation',
    description: 'optional',
  },
  {
    name: 'Asset tags',
  },
  {
    name: 'Summary',
  },
]

export const TRANSACTION_TYPE = 'add position'

export const ASSET_TYPES_LIST = ['fine art and collectables']
export const ASSET_TYPE = ASSET_TYPES_LIST[0]

export const ASSET_CLASSES_LIST = ['Fine Art and Collectables']

export const INVESTMENT_STRATEGIES_LIST = ['Fine Art', 'Collectables']
